import { setCookie, getCookie } from "./cookies";
import { hasMarketingConsent } from "./tracking";

const KEYS = ["gclid", "gbraid", "wbraid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const SESSION_KEY = "sl_attr_session";
const COOKIE = "sl_attr";

let first = {}; // first-touch
let last = {}; // last-touch (huidige aanraking)

const readLanding = () => {
  const params = new URLSearchParams(window.location.search);
  const out = { landing_page: window.location.pathname, referrer: document.referrer || "" };
  KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) out[key] = value;
  });
  return out;
};

export const initAttribution = () => {
  last = readLanding();
  try {
    first = JSON.parse(sessionStorage.getItem(SESSION_KEY) || getCookie(COOKIE) || "{}").first || {};
  } catch {
    first = {};
  }
  if (!first.first_landing_page) {
    first = { first_landing_page: last.landing_page, first_referrer: last.referrer };
    KEYS.forEach((key) => {
      if (last[key]) first[`first_${key}`] = last[key];
    });
  }
  // vóór marketing-consent: alleen sessionStorage
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({ first, last }));
  persistAttribution();
  window.addEventListener("consent-updated", persistAttribution);
  window.__getAttribution = getAttribution;
};

// na marketing-consent: persisteer in first-party cookie (90 dagen)
export const persistAttribution = () => {
  if (hasMarketingConsent() && first.first_landing_page) {
    setCookie(COOKIE, JSON.stringify({ first, last }), 90);
  }
};

export const getAttribution = () => ({ ...first, ...last });
